module.exports = __webpack_public_path__ + "img/profile-edit-white.9bd17402.svg";